var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"current_nav"},[_c('img',{attrs:{"src":"static/short_left.png"}}),_vm._v(" "+_vm._s(_vm.$store.state.language === 'cn' ? '当前位置' : 'Location')+"："+_vm._s(_vm.currentLocation)+"\r\n    ")]),_vm._v(" "),_c('div',{staticClass:"under_current_nav"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d016fa8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pageLocation.vue
// module id = null
// module chunks = 